import { __ } from '../../../locales'

const LayoutFilter = ({ selectedLayout, options, onChange }) => {
    return (
        <div className={'input-component'}>
            <label>{__('inputs.layout_type.label')}:</label>
            <select
                className="form-control"
                value={selectedLayout}
                onInput={onChange}
            >
                {options.map(type => (<option value={type.value}>{type.label}</option>))}
            </select>
        </div>
    )
};

export default LayoutFilter;
